export default "__VITE_ASSET__DFdZrkFH__"